import ListIcon from '@mui/icons-material/List';
import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const EmptyList = () => {
  return (
    <Box sx={{ color: 'text.secondary' }} className="w-100 h-vh-70">
      <Paper
        className="d-flex flex-column align-items-center justify-content-center w-100 h-100"
        elevation={0}
      >
        <ListIcon sx={{ fontSize: 50 }} />
        <Typography variant="h6">
          <FormattedMessage id="General.EmptyList" />
        </Typography>
      </Paper>
    </Box>
  );
};

export default EmptyList;
